'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _headerLocal = require('./header.local.css');

var _headerLocal2 = _interopRequireDefault(_headerLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var HeaderLink = function HeaderLink(_ref) {
  var Link = _ref.Link,
      href = _ref.href,
      children = _ref.children,
      isActive = _ref.isActive;
  return _react2.default.createElement('li', {
    className: _headerLocal2.default.menuItem
  }, _react2.default.createElement(Link, {
    to: href,
    href: href,
    className: (0, _classnames2.default)(_headerLocal2.default.menuLink, isActive && _headerLocal2.default.menuLinkActive)
  }, children));
};

HeaderLink.defaultProps = {
  isActive: false
};
HeaderLink.propTypes = {
  /**
   * NavLink from react-router
   */
  Link: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node, _propTypes2.default.element]).isRequired,

  /**
   * Path to navigate to
   */
  href: _propTypes2.default.string.isRequired,

  /**
   * Text to render for link
   */
  children: _propTypes2.default.string.isRequired,

  /**
   * Adds active display state when true
   */
  isActive: _propTypes2.default.bool
};
exports.default = HeaderLink;